<script setup lang="ts">
import type { TWinnersCategory } from '~/interfaces/winners/winnersInterfaces';
defineProps<{ tabs: ReadonlyArray<TWinnersCategory> }>();
</script>
<template>
  <div class="gap-4 justify-between mt-8 hidden md:flex">
    <WinnersCategoryPanel v-for="tab in tabs" :key="tab.key" :tab="tab" />
  </div>
</template>
